import React, { useState } from 'react';
import ProvinceCitySelect from '../components/shared/ProvinceCitySelect';

const ProvinceCityTest = () => {
  const [province, setProvince] = useState('');
  const [city, setCity] = useState('');

  return (
    <div className="p-8">
      <h1 className="text-2xl font-bold mb-6">省份城市选择测试</h1>
      
      <div className="mb-4">
        <p>当前选择的省份: {province || '未选择'}</p>
        <p>当前选择的城市: {city || '未选择'}</p>
      </div>
      
      <ProvinceCitySelect
        provinceValue={province}
        cityValue={city}
        onProvinceChange={(value) => {
          console.log('Province changed:', value);
          setProvince(value);
          setCity(''); // 清空城市选择
        }}
        onCityChange={(value) => {
          console.log('City changed:', value);
          setCity(value);
        }}
      />
    </div>
  );
};

export default ProvinceCityTest;